// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"353845e1","732":"a8e779f2","963":"3c8cb397","977":"ceba58c1"}[chunkId] + ".chunk.js";
};